import { Stack } from "@mui/material";
import { useSetAtom } from "jotai";
import { type FC } from "react";
import { Menu } from "../../../styles/icons/menu";
import { toggleSidebarAtom } from "../../layout/components/sidebar/store";
import { Logo } from "./logo";

export const HeaderBarBurger: FC = () => {
  const toggleSidebar = useSetAtom(toggleSidebarAtom);

  return (
    <Stack
      data-analytics-id="sidebar-open"
      direction="row"
      spacing={0.5}
      alignItems="center"
      onClick={toggleSidebar}
      sx={{
        cursor: "pointer",
        backgroundColor: "background.default",
        borderRadius: "16px",
        py: "8px",
        px: "12px",
        borderWidth: "0px",
      }}
      title="Open main nav"
      component="button"
    >
      <Logo sx={{ width: "20px", height: "20px" }} />
      <Menu />
    </Stack>
  );
};
